import React, { Component } from "react";
export default class About extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="about" className="section-block">
        <div className="row">
          <div className="three columns">
            <img className="profile-pic" src="images/John-image.jpg" alt="" />
          </div>

          <div className="nine columns main-col">
            <p className="section-kicker">Profile</p>
            <h2>About Me</h2>
            <p className="section-subtitle">
              Full stack engineer focused on performance, product outcomes, and scalable architecture.
            </p>
            <p>{resumeData.aboutme.firstpara}</p>
            <p>{resumeData.aboutme.secondpara}</p>

            <div className="row">
              <div className="columns contact-details">
                <h2>Contact Details</h2>
                <p className="address">
                  <span>{resumeData.name}</span>
                  <br></br>
                  <span>{resumeData.address}</span>
                </p>
              </div>
              <div className="columns download">
                <p>
                  <a href="/resume/johncletus.pdf" className="button" download>
                    <i className="fa fa-download" />
                    Download Resume
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
